import { StyleSheet } from 'react-native';
import type { Theme } from '../../../src/theme/getTheme';
import { pickContrastTextOnBackground } from '../../../helpers/pickContrastText.helper';

export function getMatchHubH2HSeasonSoFarCardStyles(theme: Theme) {
  return StyleSheet.create({
    headerRow: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginBottom: theme.spacing.md,
      minHeight: 52,
    },
    headerKitSlot: {
      width: 44,
      alignItems: 'center',
      justifyContent: 'center',
    },
    headerCenter: {
      flex: 1,
      alignItems: 'center',
      paddingHorizontal: theme.spacing.sm,
    },
    headerTitle: {
      ...theme.typography.labelSmall,
      fontWeight: '700',
      color: theme.gray[900],
      textAlign: 'center',
    },
    leagueRow: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 6,
      marginTop: 4,
    },
    leagueName: {
      ...theme.typography.caption,
      fontSize: 12,
      color: theme.gray[600],
      fontWeight: '600',
    },
    statRow: {
      flexDirection: 'row',
      alignItems: 'center',
      minHeight: 40,
      marginBottom: theme.spacing.xs,
    },
    statSide: {
      flex: 1,
      flexDirection: 'row',
      alignItems: 'center',
    },
    statSideLeft: {
      justifyContent: 'flex-end',
      paddingRight: theme.spacing.xs,
    },
    statSideRight: {
      justifyContent: 'flex-start',
      paddingLeft: theme.spacing.xs,
    },
    statCenterLabel: {
      width: 128,
      ...theme.typography.caption,
      fontSize: 11,
      fontWeight: '600',
      color: theme.gray[500],
      textAlign: 'center',
    },
    statValueText: {
      ...theme.typography.labelSmall,
      fontWeight: '700',
      color: theme.gray[900],
      paddingVertical: 4,
      paddingHorizontal: 10,
      overflow: 'hidden',
      borderRadius: theme.borderRadius.md,
    },
    statPillInner: {
      paddingVertical: 5,
      paddingHorizontal: 12,
      borderRadius: theme.borderRadius.md,
      backgroundColor: theme.error,
    },
    statPillGlyph: {
      ...theme.typography.labelSmall,
      fontWeight: '800',
      color: pickContrastTextOnBackground(theme.error),
    },
  });
}
